const localeScrollStorageKey = "buddyora:locale-scroll-position";

window.addEventListener("pageshow", () => {
  try {
    const savedPosition = sessionStorage.getItem(localeScrollStorageKey);
    if (savedPosition === null) return;
    sessionStorage.removeItem(localeScrollStorageKey);
    const scrollPosition = Number(savedPosition);
    if (Number.isFinite(scrollPosition) && scrollPosition > 0) {
      requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
    }
  } catch (_error) {
    // Storage can be unavailable in private browsing contexts.
  }
}, { once: true });

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.stickyHeader = this.closest("sticky-header");
        this.menuDrawer = this.closest(".menu-drawer");
        this.isLanguageSelector = Boolean(this.querySelector('input[name="locale_code"]'));
        this.mobileLanguageSheet = null;
        this.mobileLanguageSheetContent = null;
        this.mobileLanguageSheetClose = null;
        this.mobileLanguageSheetBackdrop = null;
        this.mobileLanguagePanelPlaceholder = null;
        this.skipNextButtonFocusLock = false;
        this.ownsMobileScrollLock = false;
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector(".country-selector__close-button"),
          resetButton: this.querySelector(".country-filter__reset-button"),
          searchIcon: this.querySelector(".country-filter__search-icon"),
          liveRegion: this.querySelector("#sr-country-search-results")
        };
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.addEventListener("focusout", this.closeSelector.bind(this));
        this.elements.button.addEventListener("click", this.openSelector.bind(this));
        this.elements.button.addEventListener("pointerdown", this.lockStickyHeader.bind(this));
        this.addEventListener("focusin", this.onSelectorFocusIn.bind(this));
        if (this.menuDrawer && this.isLanguageSelector) {
          const headerDrawer = this.menuDrawer.closest("header-drawer");
          this.mobileLanguageSheet = headerDrawer && headerDrawer.querySelector("[data-mobile-language-sheet]");
          if (this.mobileLanguageSheet) {
            this.mobileLanguageSheetContent = this.mobileLanguageSheet.querySelector("[data-mobile-language-sheet-content]");
            this.mobileLanguageSheetClose = this.mobileLanguageSheet.querySelector("[data-mobile-language-sheet-close]");
            this.mobileLanguageSheetBackdrop = this.mobileLanguageSheet.querySelector("[data-mobile-language-sheet-backdrop]");
            this.mobileLanguageSheet.addEventListener("keydown", this.onMobileLanguageSheetKeyDown.bind(this));
            this.mobileLanguageSheet.addEventListener("focusout", this.onMobileLanguageSheetFocusOut.bind(this));
            this.mobileLanguageSheetClose.addEventListener("click", () => this.hidePanel(true));
            this.mobileLanguageSheetBackdrop.addEventListener("click", () => this.hidePanel(true));
          }
        }
        if (this.elements.search) {
          this.elements.search.addEventListener("keyup", this.filterCountries.bind(this));
          this.elements.search.addEventListener("focus", this.onSearchFocus.bind(this));
          this.elements.search.addEventListener("blur", this.onSearchBlur.bind(this));
          this.elements.search.addEventListener("keydown", this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener("click", this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener("click", this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener("mousedown", (event) => event.preventDefault());
        }
        this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
      }
      hidePanel(restoreFocus = false) {
        const wasMobileSheetOpen = this.mobileLanguageSheet && !this.mobileLanguageSheet.hidden;
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        if (this.mobileLanguagePanelPlaceholder && this.mobileLanguagePanelPlaceholder.parentNode) {
          this.mobileLanguagePanelPlaceholder.parentNode.insertBefore(this.elements.panel, this.mobileLanguagePanelPlaceholder);
          this.mobileLanguagePanelPlaceholder.remove();
          this.mobileLanguagePanelPlaceholder = null;
        }
        if (this.mobileLanguageSheet) {
          this.mobileLanguageSheet.hidden = true;
          this.mobileLanguageSheet.setAttribute("aria-hidden", "true");
        }
        if (this.elements.search) {
          this.elements.search.value = "";
          this.filterCountries();
          this.elements.search.setAttribute("aria-activedescendant", "");
        }
        if (this.ownsMobileScrollLock) {
          document.body.classList.remove("overflow-hidden-mobile");
          this.ownsMobileScrollLock = false;
        }
        if (this.menuDrawer && !this.isLanguageSelector) {
          this.menuDrawer.classList.remove("country-selector-open");
        }
        if (this.stickyHeader) {
          this.releaseStickyHeader();
        }
        if (restoreFocus === true && wasMobileSheetOpen) this.focusSelectorButton();
      }
      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll("a")).filter(
          (item) => !item.parentElement.classList.contains("hidden")
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;
        switch (event.code.toUpperCase()) {
          case "ARROWUP":
            event.preventDefault();
            itemToFocus = focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case "ARROWDOWN":
            event.preventDefault();
            itemToFocus = focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }
        if (!this.elements.search) return;
        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute("aria-activedescendant", focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute("aria-activedescendant", "");
          }
        });
      }
      onContainerKeyUp(event) {
        event.preventDefault();
        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (this.elements.button.getAttribute("aria-expanded") == "false") return;
            this.hidePanel();
            event.stopPropagation();
            this.focusSelectorButton();
            break;
          case "SPACE":
            if (this.elements.button.getAttribute("aria-expanded") == "true") return;
            this.openSelector();
            break;
        }
      }
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (this.isLanguageSelector) {
          try {
            sessionStorage.setItem(localeScrollStorageKey, String(window.scrollY));
          } catch (_error) {
            // Continue with the locale change if storage is unavailable.
          }
        }
        if (form) form.submit();
      }
      openSelector() {
        const isOpening = this.elements.panel.hasAttribute("hidden");
        if (!isOpening) {
          this.hidePanel(true);
          return;
        }

        this.lockStickyHeader();
        this.elements.panel.removeAttribute("hidden");
        this.elements.button.setAttribute("aria-expanded", "true");
        if (!this.mql.matches && !document.body.classList.contains("overflow-hidden-tablet") && !document.body.classList.contains("overflow-hidden-mobile")) {
          document.body.classList.add("overflow-hidden-mobile");
          this.ownsMobileScrollLock = true;
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.menuDrawer && this.isLanguageSelector && this.mobileLanguageSheet) {
          this.openMobileLanguageSheet();
        } else if (this.menuDrawer) {
          this.menuDrawer.classList.add("country-selector-open");
        }
      }
      closeSelector(event) {
        if (this.mobileLanguageSheet && !this.mobileLanguageSheet.hidden) {
          if (this.mobileLanguageSheet.contains(event.relatedTarget)) return;
          if (this.mobileLanguageSheet.contains(event.target) && this.contains(event.relatedTarget)) return;
        }
        if (event.target.classList.contains("country-selector__overlay") || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
          this.hidePanel(Boolean(this.mobileLanguageSheet && !this.mobileLanguageSheet.hidden));
        }
      }
      onSelectorFocusIn(event) {
        if (event.target !== this.elements.button || this.skipNextButtonFocusLock) return;
        this.lockStickyHeader();
      }
      focusSelectorButton() {
        this.skipNextButtonFocusLock = true;
        this.focusWithoutScroll(this.elements.button);
        this.skipNextButtonFocusLock = false;
      }
      lockStickyHeader() {
        if (!this.hasAttribute("data-prevent-hide") || !this.stickyHeader) return;
        this.stickyHeader.preventHide = true;
        const headerSection = this.stickyHeader.header;
        if (headerSection && headerSection.classList.contains("shopify-section-header-hidden")) {
          headerSection.classList.remove("shopify-section-header-hidden");
          headerSection.classList.add("shopify-section-header-sticky", "animate");
        }
      }
      releaseStickyHeader() {
        const hasOpenHeaderMenu = this.stickyHeader.querySelector("header-menu details[open]");
        const hasOpenLocalizationSelector = this.stickyHeader.querySelector(
          'localization-form[data-prevent-hide] button.localization-form__select[aria-expanded="true"]'
        );
        this.stickyHeader.preventHide = Boolean(hasOpenHeaderMenu || hasOpenLocalizationSelector);
      }
      openMobileLanguageSheet() {
        if (!this.mobileLanguagePanelPlaceholder && this.elements.panel.parentNode) {
          this.mobileLanguagePanelPlaceholder = document.createComment("mobile-language-panel");
          this.elements.panel.parentNode.insertBefore(this.mobileLanguagePanelPlaceholder, this.elements.panel);
        }
        this.mobileLanguageSheetContent.appendChild(this.elements.panel);
        this.mobileLanguageSheet.hidden = false;
        this.mobileLanguageSheet.setAttribute("aria-hidden", "false");
        this.focusWithoutScroll(this.mobileLanguageSheetClose);
      }
      onMobileLanguageSheetKeyDown(event) {
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          this.hidePanel(true);
          return;
        }
        if (event.key !== "Tab") return;
        const focusableItems = [this.mobileLanguageSheetClose, ...this.elements.panel.querySelectorAll("a[href]")];
        if (focusableItems.length < 2) return;
        const firstItem = focusableItems[0];
        const lastItem = focusableItems[focusableItems.length - 1];
        if (event.shiftKey && document.activeElement === firstItem) {
          event.preventDefault();
          lastItem.focus();
        } else if (!event.shiftKey && document.activeElement === lastItem) {
          event.preventDefault();
          firstItem.focus();
        }
      }
      onMobileLanguageSheetFocusOut(event) {
        if (!this.mobileLanguageSheet.contains(event.relatedTarget) && !this.contains(event.relatedTarget)) {
          this.hidePanel(true);
        }
      }
      focusWithoutScroll(element) {
        if (!element) return;
        try {
          element.focus({ preventScroll: true });
        } catch (_error) {
          element.focus();
        }
      }
      normalizeString(str) {
        return str.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
      }
      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector(".popular-countries");
        const allCountries = this.querySelectorAll("a");
        let visibleCountries = allCountries.length;
        this.elements.resetButton.classList.toggle("hidden", !searchValue);
        if (popularCountries) {
          popularCountries.classList.toggle("hidden", searchValue);
        }
        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector(".country").textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove("hidden");
            visibleCountries++;
          } else {
            item.parentElement.classList.add("hidden");
            visibleCountries--;
          }
        });
        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            "[count]",
            visibleCountries
          );
        }
        this.querySelector(".country-selector").scrollTop = 0;
        this.querySelector(".country-selector__list").scrollTop = 0;
      }
      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = "";
        this.filterCountries();
        this.elements.search.focus();
      }
      onSearchFocus() {
        this.elements.searchIcon.classList.add("country-filter__search-icon--hidden");
      }
      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove("country-filter__search-icon--hidden");
        }
      }
      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === "ENTER") {
          event.preventDefault();
        }
      }
    }
  );
}
